export const chunkData = (array, chunkSize) => {
  const result = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }
  return result;
};

export const removeCharacter = (inputString, characterToRemove) => {
  if(inputString){
  if (typeof inputString !== 'string' || typeof characterToRemove !== 'string') {
    throw new Error('Ambos argumentos deben ser cadenas de texto.');
  }

    return inputString.split(characterToRemove).join(' ').replace(/\s{2,}/g, ' ');
  }
  else{
    return ''
  }
};